import { Component, OnInit } from '@angular/core';
import { VcrBaseComponent } from '../vcr-report-base.component';
import { InspectionService } from '../inspection.service';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationStateService } from '@quorum/authentication/services';
import { MediaObserver } from '@angular/flex-layout';
import { BreakpointObserver } from '@angular/cdk/layout';
import { SystemControlStateService } from '@quorum/xsr-system-control/services';
import { ApiService } from '@quorum/api';

@Component({
  selector: 'quorum-vcr-report-display-gm-print',
  templateUrl: './vcr-report-display-gm-print.component.html',
  styleUrls: ['./vcr-report-display-gm-print.component.scss'],
})
export class VcrReportDisplayGmPrintComponent extends VcrBaseComponent implements OnInit {
  constructor(
    public inspectionService: InspectionService,
    public activatedRoute: ActivatedRoute,
    public authenticationStateService: AuthenticationStateService,
    public mediaService: MediaObserver,
    public breakpointObserver: BreakpointObserver,
    public systemControlStateService: SystemControlStateService,
    public apiService: ApiService
  ) {
    super(
      inspectionService,
      activatedRoute,
      authenticationStateService,
      mediaService,
      breakpointObserver,
      systemControlStateService,
      apiService
    );
  }
  ngOnInit() {
    console.log(this.inspectionService.dealershipLogo);
    this.Init();
  }
}
